<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.grupos"
            class="mt-3"
        >
            <template v-slot:cell(dispensar)="{ item }">
                <rkm-form-checkbox
                    v-model="item.dispensar"
                    @change="onChange(item)"
                    :indeterminate="item.materiais.filter(material => material.dispensar).length > 0  && item.materiais.filter(material => material.dispensar).length < item.materiais.length"
                />
            </template>

            <template v-slot:cell(dispensaveis)="{ item }">
                {{ `${item.dispensar ? item.materiais.length : item.materiais.filter(material => material.dispensar).length}/${item.materiais.length}` }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="configurarMateriais(item)"
                    color="primary"
                    small
                >
                    <rkm-icon icon="cog" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal ref="Modal" :data="data.model"/>
    </div>
</template>

<script>
import Modal from './Modal'

import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    components: { Modal },
    computed: {
        fields() {

            return [
                {
                    key: 'dispensar',
                    label: 'Dispensar',
                    class: 'col-min text-center'
                },
                {
                    key: 'nome',
                    label: 'Grupo',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dispensaveis',
                    label: 'Materiais',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        onChange(grupo) {
            grupo.materiais = grupo.materiais.map(material => ({...material, dispensar: grupo.dispensar}))
        },
        configurarMateriais(grupo) {
            this.$refs.Modal.open(grupo)
        },
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true }
    }
}
</script>